export default {
  'topBar.issuesHistory': 'Issues History',
  'topBar.projectManagement': 'Project Management',
  'topBar.typeToSearch': 'Search...',
  'topBar.findPages': 'Find pages...',
  'topBar.actions': 'Actions',
  'topBar.status': 'Status',
  'topBar.profileMenu.hello': 'Hello',
  'topBar.profileMenu.billingPlan': 'Billing Plan',
  'topBar.profileMenu.role': 'Role',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Phone',
  'topBar.profileMenu.editProfile': 'Edit Profile',
  'topBar.profileMenu.logout': 'Logout',
  'topBar.export.options.excel': 'Export report to Excel',
  'topBar.export.options.pdf': 'Export report to PDF',
  'topBar.user.manual': 'User Manual',
  'topBar.user.acr': 'Application Change Request',
  'topBar.app.version': 'SPAS release',
  'topBar.app.installed.modules': 'Installed Modules',
  'topBar.third.party.license': 'Third Party License Notes',
  'topBar.cookie.policy': 'Cookie Policy',
  'topBar.profileMenu.company': 'Company',
  'topBar.profileMenu.installation': 'Installation',
}
